import { ChevronDownIcon, InfoOutlineIcon } from '@chakra-ui/icons';
import {
    Box, Button,
    Card,
    CardBody,
    Collapse, Flex, Icon,
    Menu,
    MenuButton,
    MenuItem,
    MenuList,
    Radio,
    RadioGroup,
    Stack,
    Text,
    Tooltip,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import CatalogueFrameForSingle from 'components/genericForms/CatalogueFrameForSingle';
import CustomDeepLinkInput from 'components/genericForms/CustomDeepLinkInput';
import { useFormik } from 'formik';
import { useState } from 'react';
import { FiChevronUp } from 'react-icons/fi';
import { MdClose, MdEdit } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { useUpdateAdspressoAdCreativeByIdMutation } from 'store/adspresso/adspressoAdApi';
import { removeEmptyValues } from 'utils/functions';
import { object, string } from "yup";

let schema = object().shape({
    destinationType: string(),
    type: string()
        .required('Type is required'),
})

function CatalogueCarouselMediaUpdateForm({ creative, adAccount, onDelete }) {

    const toast = useToast();
    const inputBackground = useColorModeValue('#F5F3F9', '#1e1530');
    const [isCollapsed, setisCollapsed] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const userInfo = useSelector((state) => state.auth?.userInfo);
    const { isOpen: isCreativeModalOpen, onOpen: onCreativeModalOpen, onClose: onCreativeModalClose } = useDisclosure();

    const [updateAdspressocreativeAds, { isLoading: isAdspressoAdsetUpdating }] = useUpdateAdspressoAdCreativeByIdMutation({});

    const { description, image_hash, name, thumbnail, type, url, video_id, _id, product_set_id, adcreatives, image_layer_specs, format_option } = creative || {}

    const singleMediaFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: name || '',
            description: description || '',
            type: type,
            url: url || '',
            product_set_id: product_set_id || '',
            image_layer_specs: Array.isArray(image_layer_specs)
                ? image_layer_specs
                : [],
            format_option: format_option || 'carousel_images_multi_items',
        },
        validationSchema: schema,
        onSubmit: (values, { resetForm }) => {

            const { name, description, url, type, product_set_id, image_layer_specs, format_option } = values;

            let videoId = video_id ? { video_id } : null;
            let imageHash = image_hash ? { image_hash } : null;
            let thumbnail_ = thumbnail ? { thumbnail } : null;

            const filtered_image_layer_specs = image_layer_specs?.map(layer => {
                // Create a shallow copy of the object without frame_name and frame_url
                const { frame_name, frame_url, ...rest } = layer;
                return rest;
            }) || [];

            const payload = {
                name,
                description,
                url,
                type,
                product_set_id,
                format_option,
                ...(filtered_image_layer_specs.length > 0 && format_option === 'carousel_images_multi_items' && {
                    image_layer_specs: filtered_image_layer_specs,
                }),
                ...thumbnail_,
                ...videoId,
                ...imageHash
            };

            const filteredPayload = removeEmptyValues(payload);

            try {
                updateAdspressocreativeAds({ adcreativeId: _id, payload: filteredPayload }).unwrap()
                    .then(response => {
                        toast({
                            position: "top-right",
                            title: "Ad creative updated",
                            status: "success",
                            duration: 4000,
                            isClosable: true,
                        });
                    })
                    .catch(error => {
                        const errorMessage = error?.data?.message || "An unexpected error occurred";
                        const formattedMessage = errorMessage.replace(/['"]/g, '');

                        toast({
                            position: "top-right",
                            title: "Error updating Ad creative",
                            description: formattedMessage,
                            status: "error",
                            duration: 4000,
                            isClosable: true,
                        });
                    });
            } catch (error) {
                // console.log(error);

            } finally {
                setisCollapsed(false);
                resetForm();
            }
        }
    });

    return (
        <>
            {/* Modal for "Add a frame" */}
            {isCreativeModalOpen && 
                <CatalogueFrameForSingle 
                    isOpen={isCreativeModalOpen}
                    onClose={onCreativeModalClose}
                    productSetId={product_set_id}
                    selectedAdAccounts={[{
                        adsAccountId: adAccount?.adsAccountId,
                        adsAccountName: adAccount?.adsAccountName,
                    }]}
                    values={singleMediaFormik.values}
                    onChangeImageLayerSpecs={(framesData) => {
                        singleMediaFormik.setFieldValue(
                            "image_layer_specs",
                            framesData
                    )}}
                />
            }

            <Box key={url} p={1} borderWidth={1} borderRadius="md" borderColor="gray.200">
                <Flex alignItems="center" gap={2} justify="space-between">
                    <Flex alignItems="center" gap={2}>
                        <Flex direction={'column'}>
                            <Text fontSize="10px" noOfLines={1}>
                                {name}
                            </Text>

                            {/* <Flex gap={1}>
                                {singleMediaFormik.values.description ? (
                                    <Text fontSize="10px" noOfLines={1}>{truncateName(singleMediaFormik.values?.description)}</Text>
                                ) : (
                                    <Text fontSize="10px">Enter a description</Text>
                                )}
                            </Flex> */}
                        </Flex>

                    </Flex>
                    <Flex alignItems="center" gap={'5px'}>
                        <Tooltip label="Edit copy" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.500' }}
                                    as={isCollapsed ? FiChevronUp : MdEdit}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    onClick={() => userInfo?.role === 'client' && setisCollapsed(!isCollapsed)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'inherit'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                        <Tooltip label="Remove creative" fontSize="xs">
                            <Box>
                                <Icon
                                    _hover={{ color: 'gray.400' }}
                                    as={MdClose}
                                    cursor={userInfo?.role !== 'client' ? 'not-allowed' : 'pointer'}
                                    boxSize={5}
                                    onClick={() => userInfo?.role === 'client' && onDelete(_id)}
                                    color={userInfo?.role !== 'client' ? 'gray.300' : 'red.500'}
                                    pointerEvents={userInfo?.role !== 'client' ? 'none' : 'auto'}
                                />
                            </Box>
                        </Tooltip>
                    </Flex>
                </Flex>
                <Collapse in={isCollapsed}>
                    <Box p={'10px'}>
                        <Flex direction={'column'}>
                            <Box mb={'0px'} mt={'10px'}>

                                <Flex align="center" wrap="wrap" mb={2} gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Creative options</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                            <Box fontSize="12px" p="5px">
                                                <Text>
                                                    Choose a creative format for your carousel cards. The slideshow format will default to a single image if you don't provide more than one image per item.
                                                </Text>
                                            </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                </Flex>

                                <Flex mb={2}>
                                    <RadioGroup
                                        name="format_option"
                                        value={singleMediaFormik.values.format_option}
                                        onChange={(value) => {
                                            singleMediaFormik.setFieldValue('format_option', value);
                                        }}
                                    >
                                        <Stack spacing={5} direction='column'>
                                        <Flex direction="column">
                                            <Flex align="center">
                                            <Radio colorScheme='brand' value='carousel_images_multi_items' />
                                            <Text fontWeight="bold" ml={2} fontSize={'14px'}>Single image</Text>
                                            </Flex>
                                            <Text fontSize={'12px'} ml={6}>Show one image per card for each item in your catalog.</Text>
                                        </Flex>

                                        <Flex direction="column">
                                            <Flex align="center">
                                            <Radio colorScheme='brand' value='carousel_slideshows' />
                                            <Text fontWeight="bold" ml={2} fontSize={'14px'}>Slideshow </Text>
                                            </Flex>
                                            <Text fontSize={'12px'} ml={6}>Create a looping video for each card using multiple images per item.</Text>
                                        </Flex>
                                        </Stack>
                                    </RadioGroup>
                                </Flex>

                                {(singleMediaFormik.values.format_option === 'carousel_slideshows') ?
                                        <Card 
                                            borderRadius="5px" 
                                            p={2}
                                            borderLeft={"4px solid"}
                                            borderColor={"gray.100"}
                                            mb={2}
                                        >
                                            <CardBody as={Flex} align="flex-start" gap={2} p={1}>
                                                <InfoOutlineIcon style={{ pointerEvents: 'all' }} />
                                                <Text fontSize="12px">
                                                    Make sure you have multiple images for each item in your product set. When multiple images aren't available, a single image shows instead.
                                                </Text>
                                            </CardBody>
                                        </Card>
                                    :
                                        <>
                                            <Flex align="center" wrap="wrap" mb={2} gap={2}>
                                                <Text fontWeight="bold" fontSize={'14px'}>Creative tools</Text>
                                                <Tooltip
                                                    borderRadius={5}
                                                    label={
                                                    <Box fontSize="12px" p="5px">
                                                        <Text>
                                                        Customise how images from your catalogue appear in your ads. Frame products and services with engaging graphics and add helpful info from your catalogue, such as price or free delivery.
                                                        </Text>
                                                    </Box>
                                                    }
                                                    fontSize="md"
                                                >
                                                    <InfoOutlineIcon pointerEvents="all" />
                                                </Tooltip>
                                            </Flex>
                                            <Flex mb={2}>
                                                <Menu>
                                                <MenuButton
                                                    as={Button}
                                                    variant="outline"
                                                    fontWeight="normal"
                                                    bg={inputBackground}
                                                    _active={{ background: inputBackground, borderColor: "blue.500" }}
                                                    _hover={{ background: inputBackground, borderColor: "gray.300" }}
                                                    rightIcon={<ChevronDownIcon boxSize={5} />}
                                                    size="sm"
                                                >
                                                Edit creative
                                                </MenuButton>
                                                <MenuList minW="135px" px={2} py={1}>
                                                <MenuItem
                                                    fontSize="14px"
                                                    onClick={onCreativeModalOpen}
                                                >
                                                    Add a frame
                                                </MenuItem>
                                                </MenuList>
                                                </Menu>
                                            </Flex>
                                        </>
                                }
                                <Flex mb={'20px'} direction="column">
                                    <Flex alignItems="center" mb={2} gap={2}>
                                        <Text fontSize="14px" fontWeight="bold">Headline</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="12px" p="5px">
                                                    <Text>
                                                        Add up to five brief headlines to let people know what your ad is about. Each
                                                        headline can have a maximum of 255 characters. Headlines won't appear in all
                                                        placements.
                                                    </Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                     <CustomDeepLinkInput
                                        value={singleMediaFormik.values.name}
                                        onChange={(name) => singleMediaFormik.setFieldValue('name', name)}
                                        error={
                                            singleMediaFormik?.touched?.name &&
                                            singleMediaFormik?.errors?.name
                                        }
                                        placeholder={'Add an attention-grabbing headline'}
                                        maxW='330px'
                                    />
                                </Flex>

                                <Flex justifyContent="flex-start" mt={'20px'}>
                                    <Button
                                        colorScheme="brand"
                                        onClick={() => singleMediaFormik.handleSubmit()}
                                        size={'sm'}
                                        isLoading={isAdspressoAdsetUpdating}
                                    >
                                        Save
                                    </Button>
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>
                </Collapse>
            </Box>
        </>
    )
}

export default CatalogueCarouselMediaUpdateForm;
